import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import { useAuthStore } from './stores/authStore';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska"

import VueFeather from 'vue-feather';

import '@/assets/scss/config/default/app.scss';
import "leaflet/dist/leaflet.css";
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle'

AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

// Create Pinia instance
const pinia = createPinia();

// Create app
const app = createApp(App);

// Install plugins
app.use(pinia)
   .use(router)
   .use(VueApexCharts)
   .use(BootstrapVueNext)
   .component(VueFeather.type, VueFeather)
   .directive("maska", vMaska)
   .use(i18n)
   .use(VueSweetalert2)
   .use(vClickOutside);

// Global error handler
app.config.errorHandler = (err, instance, info) => {
  console.error('Global error:', err)
  console.error('Component:', instance)
  console.error('Error info:', info)

  // You can send to monitoring service here (e.g., Sentry)
  // if (import.meta.env.PROD) {
  //   Sentry.captureException(err)
  // }

  // Show user-friendly error message
  import('sweetalert2').then(({ default: Swal }) => {
    Swal.fire({
      icon: 'error',
      title: 'Unexpected Error',
      text: 'An unexpected error occurred. Please refresh the page and try again.',
      confirmButtonColor: '#d33'
    })
  })
}

// Global warning handler
app.config.warnHandler = (msg, instance, trace) => {
  if (import.meta.env.DEV) {
    console.warn('Vue warning:', msg)
    console.warn('Component:', instance)
    console.warn('Trace:', trace)
  }
}

// Initialize auth store and hydrate user if token exists
const authStore = useAuthStore();
if (authStore.token) {
  authStore.fetchUser().catch(() => {
    // Token invalid, logout
    authStore.logout();
  });
}

// Mount app
app.mount('#app');